export const color = [
  "white",
  "Black",
  "Red",
  "marun",
  "Being",
  "Pink",
  "Green",
  "Yellow",
];

export const filters = [
  {
    id: "Sticks",
    name: "Incense Sticks",
    options: [
      { value: "Incense Sticks", label: "Incense Sticks" },
      // { value: "beige", label: "Beige" },
      // { value: "blue", label: "Blue" },
      // { value: "brown", label: "Brown" },
      // { value: "green", label: "Green" },
      // { value: "purple", label: "Purple" },
      // {value:"yellow",label:"Yellow"}
    ],
  },

  {
    id: "Cones",
    name: "Incense Cones",
    options: [
      { value: "Incense", label: "Incense Cones" },
    ,
    ],
  },
  
];

export const singleFilter=[
  {
    id: "Incense",
    name: "Incense Cup",
    options: [
      { value: "Incense Cup", label: "Incense Cup" },
     
    ],
  },
  {
    id: "gift",
    name: "Gift Hampers",
    options: [
  
      { value: "Gift Hampers", label: "Gift Hampers" },
     
    ],
  },
  {
    id: "stock",
    name: "Gulab Jal",
    options: [
      { value: "Gulab Jal", label: "Gulab Jal" },
     
      
    ],
  },
    {
    id: "stock",
    name: "Ashtagandha",
    options: [
      { value: "Ashtagandha", label: "Ashtagandha" },
      { value: "out_of_stock", label: "Out Of Stock" },
      
    ],
  },

]

export const sortOptions = [
  
  { name: "Price: Low to High", query: "price_low", current: false },
  { name: "Price: High to Low", query: "price_high", current: false },
];
